import i18n from '@/i18n';
import moment from 'moment';
import { STR_DATE_TIME, formatDateCommon, convertMbToKb, convertKBtoMB } from '@/utils/format';
import { onHandleShowConfirm } from '@/utils/handlers';
// formatMergeDateAndTime
import {
    STATUS_FORM,
    initForm,
    initSettingPage,
    PAGE_TYPES,
    PAGE_TYPE_FIXED,
    TAB_NAME,
    initOutputCalendar,
    initLayoutPrizeSerial,
    ID_PAGE_TYPE
} from './constants';
import { showMessage } from '@/utils/messages';
import { OPTION_INPUT_FORMAT, OPTION_INPUT_FORMAT_FULL_NAME, OPTION_AGE_CONDITION } from './components/setting-block-form/constants';
import { cloneDeep } from 'lodash';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { VALUE_ETC, VALUE_NAC, onHandleGetValueTextAlign } from './iframe-page/handlers';

import { options as optionsDesign } from './components/setting-design/constants';
import { managerFormService } from '@/api/services/manager-form.service';

const handleStatus = (status, list = STATUS_FORM) => {
    if (!status) return '';
    return list.find((s) => s.id == status)?.value ?? '';
};

const handleDataBeforeSendServer = (formData) => {
    let dataSave = JSON.parse(JSON.stringify(formData));
    return {
        ...(dataSave.id !== null &&
            dataSave.id !== undefined && {
                id: dataSave.id,
                is_a_changed: true,
                form_pages: handleDataFormPage(dataSave),
                meta_title: dataSave?.meta_title ?? '',
                description: dataSave?.description ?? '',
                header: dataSave?.header ?? '',
                footer: dataSave?.footer ?? '',
                google_analytics: dataSave?.google_analytics ?? '',
                setting_designs: handleSettingDesign(dataSave.setting_designs),
                registration_email_template: dataSave?.registration_email_template
                    ? {
                          ...dataSave?.registration_email_template,
                          invite: {
                              ...dataSave?.registration_email_template?.invite,
                              email_sender: {
                                  id: dataSave?.registration_email_template?.invite?.email_sender?.id,
                                  email_address: dataSave?.registration_email_template?.invite?.email_sender?.email_address
                              },
                              template: {
                                  id: dataSave?.registration_email_template?.invite?.template?.id,
                                  template_name: dataSave?.registration_email_template?.invite?.template?.template_name
                              },
                              template_name: dataSave?.registration_email_template?.invite?.template?.template_name
                          }
                      }
                    : {},
                setting_serial_code: {
                    ...dataSave.setting_serial_code
                },
                serial_code_prizes:
                    dataSave.serial_code_prizes?.length > 0
                        ? dataSave.serial_code_prizes.map((item, idx) => {
                              delete item.make_id;
                              item.order_index = item.order_index || idx + 1;
                              item.image = item.image?.id ? { id: item.image?.id } : null;
                              item.width_image = item.width_image?.toString() ?? null;
                              item.height_image = item.height_image?.toString() ?? null;
                              item.number_in_kind = item.number_in_kind?.toString() ? Number(item.number_in_kind) : null;
                              item.blocks = (item.blocks || []).map((blockItem, bIdx) => {
                                  return onHandleSendListBlock(blockItem, bIdx, item.blocks);
                              });
                              item.prize_date_event = {
                                  daily_limits:
                                      item.prize_date_event?.daily_limits?.length > 0
                                          ? item.prize_date_event.daily_limits.map((item) => initOutputCalendar(item))
                                          : []
                              };
                              return item;
                          })
                        : []
            }),
        campaign: dataSave?.campaign?.id
            ? {
                  id: dataSave?.campaign?.id
              }
            : null,
        client: dataSave?.client?.id
            ? {
                  id: dataSave?.client?.id
              }
            : null,
        name: dataSave.name,
        custom_domain_id: dataSave.custom_domain_id,
        url_public: dataSave.url_public,
        // status: dataSave.status,
        // is_publish_start_date_now: dataSave.is_publish_start_date_now,
        // publish_has_no_end_date: dataSave.publish_has_no_end_date,
        // publish_start_date: formatMergeDateAndTime(dataSave.publish_start_date, dataSave.publish_start_time),
        // publish_end_date: formatMergeDateAndTime(dataSave.publish_end_date, dataSave.publish_end_time),
        application_limit: dataSave.application_limit,
        url_redirect_when_limit: dataSave.url_redirect_when_limit,
        reservation_display_url: dataSave.reservation_display_url,
        expired_display_url: dataSave.expired_display_url,
        mail_to: dataSave.mail_to,
        save_form_temporarily: dataSave.save_form_temporarily,
        temporary_expiration_date: dataSave.temporary_expiration_date,
        hashtag: dataSave.hashtag,
        url_parameters: dataSave.url_parameters ?? [],
        type: dataSave?.page_type?.id ?? null,
        template: dataSave?.template ?? null,
        link_expiration_time: dataSave?.link_expiration_time ?? '',
        allow_duplicate_email: dataSave?.allow_duplicate_email ?? false,
        setting_not_register_again: dataSave?.setting_not_register_again ?? null,
        setting_lottery: dataSave.setting_lottery ?? null,
        before_the_period_url: dataSave?.before_the_period_url ?? '',
        after_the_period_url: dataSave?.after_the_period_url ?? ''
    };
};

const handleSettingDesign = (data) => {
    return {
        ...data,
        character_settings: {
            ...data.character_settings,
            qa_typography: {
                ...data.character_settings.qa_typography,
                unit: data.character_settings.qa_typography?.unit?.value,
                font: data.character_settings.qa_typography?.font?.value
            },
            error_typography: {
                ...data.character_settings.error_typography,
                unit: data.character_settings.error_typography?.unit?.value,
                font: data.character_settings.error_typography?.font?.value
            },
            heading_style: data.character_settings.heading_style?.value
        },
        background_settings: {
            ...data.background_settings,
            horizontal_direction: data.background_settings.horizontal_direction?.value,
            vertical_direction: data.background_settings.vertical_direction?.value
        },
        background_image: data.background_image
            ? {
                  id: data.background_image.id
              }
            : null,
        table_settings: {
            ...data.table_settings,
            width: {
                ...data.table_settings.width,
                unit: data.table_settings.width?.unit?.value
            },
            display_position_in_browser: {
                top: {
                    ...data.table_settings.display_position_in_browser.top,
                    unit: data.table_settings.display_position_in_browser.top?.unit?.value
                },
                bottom: {
                    ...data.table_settings.display_position_in_browser.bottom,
                    unit: data.table_settings.display_position_in_browser.bottom?.unit?.value
                },
                left: {
                    ...data.table_settings.display_position_in_browser.left,
                    unit: data.table_settings.display_position_in_browser.left?.unit?.value
                },
                right: {
                    ...data.table_settings.display_position_in_browser.right,
                    unit: data.table_settings.display_position_in_browser.right?.unit?.value
                }
            },
            border_setting: {
                ...data.table_settings.border_setting,
                type: data.table_settings.border_setting?.type?.value
            },
            line_thickness: {
                ...data.table_settings.line_thickness,
                unit: data.table_settings.line_thickness?.unit?.value
            },
            cell_setting: {
                spacing: {
                    ...data.table_settings.cell_setting.spacing,
                    unit: data.table_settings.cell_setting.spacing?.unit?.value
                },
                margin: {
                    ...data.table_settings.cell_setting.margin,
                    unit: data.table_settings.cell_setting.margin?.unit?.value
                }
            }
        }
    };
};

const handleDataResponse = (dataForm, data) => {
    dataForm.id = data?.id ?? null;
    dataForm.is_a_changed = data?.is_a_changed === 1 ? true : false;
    dataForm.campaign = data?.campaign ?? null;
    dataForm.campaign_not_change = data?.campaign ?? null;
    dataForm.client = data?.client ?? null;
    dataForm.name = data?.name ?? '';
    dataForm.custom_domain_id = data?.custom_domain_id ?? data?.custom_domain?.id ?? null;
    dataForm.custom_domain = data?.custom_domain ?? null;
    dataForm.url_public = data?.url_public ?? '';
    dataForm.status = data?.status ?? '';
    dataForm.is_publish_start_date_now = data?.is_publish_start_date_now ?? false;
    dataForm.publish_has_no_end_date = data?.publish_has_no_end_date ?? false;
    dataForm.publish_start_time = formatDateCommon(data?.publish_start_date, 'dateTime');
    dataForm.publish_end_time = formatDateCommon(data?.publish_end_date, 'dateTime');
    dataForm.publish_start_date = formatDateCommon(data?.publish_start_date, 'date');
    dataForm.publish_end_date = formatDateCommon(data?.publish_end_date, 'date');
    dataForm.published = data?.published ?? null;
    dataForm.published_domain = data?.published_domain ?? null;
    dataForm.application_limit = data?.application_limit ?? '';
    dataForm.url_redirect_when_limit = data?.url_redirect_when_limit ?? '';
    dataForm.reservation_display_url = data?.reservation_display_url ?? '';
    dataForm.expired_display_url = data?.expired_display_url ?? '';
    dataForm.mail_to = data?.mail_to ?? '';
    dataForm.save_form_temporarily = data?.save_form_temporarily ?? '';
    dataForm.temporary_expiration_date = data?.temporary_expiration_date ?? '';
    dataForm.hashtag = data?.hashtag ?? '';
    dataForm.url_parameters = data?.url_parameters?.length > 0 ? data.url_parameters : [];
    dataForm.page_type = data.type ? PAGE_TYPE_FIXED.find((pty) => pty.id == data.type) : PAGE_TYPE_FIXED[0];
    dataForm.setting_page = initSettingPage(data.type);
    dataForm.link_expiration_time = data?.link_expiration_time ?? '';
    dataForm.allow_duplicate_email = data?.allow_duplicate_email === 1 ?? false;
    dataForm.setting_not_register_again = data?.setting_not_register_again ?? null;

    dataForm.template = data.template ?? null;
    dataForm.campaign_forms = data?.campaign_forms ?? [];
    dataForm.campaign_lps = data?.campaign_lps ?? [];

    dataForm.meta_title = data?.meta_title ?? '';
    dataForm.header = data?.header ?? '';
    dataForm.footer = data?.footer ?? '';
    dataForm.google_analytics = data?.google_analytics ?? '';
    dataForm.description = data?.description ?? '';
    dataForm.is_first_create = data?.is_first_create === 0 ? false : true;

    dataForm.form_pages = data?.form_pages;
    dataForm.registration_email_template = {
        ...dataForm.registration_email_template,
        ...data?.registration_email_template
    };

    dataForm.setting_serial_code = {
        ...dataForm.setting_serial_code,
        ...data?.setting_serial_code,
        serial_codes:
            data?.setting_serial_code?.serial_codes?.length > 0
                ? data.setting_serial_code?.serial_codes.map((item) => ({ ...item, make_id: item.id }))
                : [],
        mail_common: data?.mail_common ?? false
    };
    dataForm.setting_lottery = {
        ...dataForm.setting_lottery,
        ...data?.setting_lottery
    };
    dataForm.serial_code_prizes =
        data?.serial_code_prizes?.length > 0
            ? data?.serial_code_prizes.map((item) => {
                  item.make_id = item.id;
                  item.blocks = (item.blocks || []).map((blockItem) => {
                      return onHandleUnfoldBlock(blockItem, item.blocks, dataForm.setting_designs);
                  });
                  return item;
              })
            : [];

    dataForm.setting_digital_gift = {
        ...dataForm.setting_digital_gift,
        title_digital: data?.title_digital ?? '',
        top_text_digital: data?.top_text_digital ?? '',
        bottom_text_digital: data?.bottom_text_digital ?? '',
        selected_item_digital: data?.selected_item_digital ?? '',
        probability_of_winning_digital: data?.probability_of_winning_digital ?? '',
        result_digital: data?.result_digital ?? '',
        rejection_text_digital: data?.rejection_text_digital ?? ''
    };
    dataForm.block_email_validates = data?.block_email_validates ?? [];
    dataForm.block_email_condition_validates = data?.block_email_condition_validates ?? [];
    dataForm.block_condition_validates = data?.block_condition_validates ?? [];
    dataForm.setting_email_block_client_to_address_conditions = data?.setting_email_block_client_to_address_conditions ?? [];
    dataForm.before_the_period_url = data?.before_the_period_url ?? '';
    dataForm.after_the_period_url = data?.after_the_period_url ?? '';

    dataForm.setting_designs = handleMapSettingDesign(data);

    handleMapBlockRes(dataForm, data);

    return dataForm;
};

const handleMapSettingDesign = (data) => {
    const dataInit = initForm();
    const dataSettingDesigns = data.setting_designs;
    return dataSettingDesigns
        ? {
              ...dataSettingDesigns,
              character_settings: {
                  ...dataSettingDesigns.character_settings,
                  qa_typography: {
                      ...dataSettingDesigns.character_settings.qa_typography,
                      unit: optionsDesign.units.find((item) => item.value === dataSettingDesigns.character_settings.qa_typography?.unit),
                      font: optionsDesign.fontFamily.find((item) => item.value === dataSettingDesigns.character_settings.qa_typography?.font)
                  },
                  error_typography: {
                      ...dataSettingDesigns.character_settings.error_typography,
                      unit: optionsDesign.units.find((item) => item.value === dataSettingDesigns.character_settings.error_typography?.unit),
                      font: optionsDesign.fontFamily.find((item) => item.value === dataSettingDesigns.character_settings.error_typography?.font)
                  },
                  heading_style: optionsDesign.headingStyles.find((item) => item.value === dataSettingDesigns.character_settings.heading_style)
              },
              background_settings: {
                  ...dataSettingDesigns.background_settings,
                  horizontal_direction: optionsDesign.directions.find(
                      (item) => item.value === dataSettingDesigns.background_settings.horizontal_direction
                  ),
                  vertical_direction: optionsDesign.directionsvertical.find(
                      (item) => item.value === dataSettingDesigns.background_settings.vertical_direction
                  )
              },
              table_settings: {
                  ...dataSettingDesigns.table_settings,
                  width: {
                      ...dataSettingDesigns.table_settings.width,
                      unit: optionsDesign.unitsIncludeAuto.find((item) => item.value === dataSettingDesigns.table_settings.width?.unit)
                  },
                  display_position_in_browser: {
                      top: {
                          ...dataSettingDesigns.table_settings.display_position_in_browser.top,
                          unit: optionsDesign.units.find(
                              (item) => item.value === dataSettingDesigns.table_settings.display_position_in_browser.top?.unit
                          )
                      },
                      bottom: {
                          ...dataSettingDesigns.table_settings.display_position_in_browser.bottom,
                          unit: optionsDesign.units.find(
                              (item) => item.value === dataSettingDesigns.table_settings.display_position_in_browser.bottom?.unit
                          )
                      },
                      left: {
                          ...dataSettingDesigns.table_settings.display_position_in_browser.left,
                          unit: optionsDesign.unitsIncludeAuto.find(
                              (item) => item.value === dataSettingDesigns.table_settings.display_position_in_browser.left?.unit
                          )
                      },
                      right: {
                          ...dataSettingDesigns.table_settings.display_position_in_browser.right,
                          unit: optionsDesign.unitsIncludeAuto.find(
                              (item) => item.value === dataSettingDesigns.table_settings.display_position_in_browser.right?.unit
                          )
                      }
                  },
                  border_setting: {
                      ...dataSettingDesigns.table_settings.border_setting,
                      type: optionsDesign.borderTypes.find((item) => item.value === dataSettingDesigns.table_settings.border_setting.type)
                  },
                  line_thickness: {
                      ...dataSettingDesigns.table_settings.line_thickness,
                      unit: optionsDesign.units.find((item) => item.value === dataSettingDesigns.table_settings.line_thickness?.unit)
                  },
                  cell_setting: {
                      spacing: {
                          ...dataSettingDesigns.table_settings.cell_setting.spacing,
                          unit: optionsDesign.units.find((item) => item.value === dataSettingDesigns.table_settings.cell_setting.spacing?.unit)
                      },
                      margin: {
                          ...dataSettingDesigns.table_settings.cell_setting.margin,
                          unit: optionsDesign.units.find((item) => item.value === dataSettingDesigns.table_settings.cell_setting.margin?.unit)
                      }
                  }
              }
          }
        : dataInit.setting_designs;
};

const handleMapBlockRes = (dataForm, data, typeStatusBlock = null) => {
    if ([ID_PAGE_TYPE.C].includes(Number(data.type))) {
        dataForm.setting_page['pages'] = dataForm.setting_page['pages'].map((pageItem) => {
            let matchingPage = '';
            switch (pageItem.title) {
                case i18n.t('managerForm.settingPage.screenInput'):
                    matchingPage = PAGE_TYPES._C[0];
                    break;
            }
            if (!data?.form_pages[matchingPage]) return pageItem;
            if (data?.form_pages[matchingPage].title !== i18n.t('managerForm.settingPage.screenInput') && data?.form_pages[matchingPage]?.id) {
                pageItem.id = data?.form_pages[matchingPage]?.id;
            }
            const formatArray = Array.isArray(data?.form_pages[matchingPage]) ? data?.form_pages[matchingPage] : [data?.form_pages[matchingPage]];

            if (matchingPage === PAGE_TYPES._C[0]) {
                pageItem.page_child = mapPageChildRes(dataForm, formatArray, matchingPage, null, typeStatusBlock);
            }
            return pageItem;
        });
        return;
    }

    if (data?.form_pages.page_inputs && data?.form_pages.page_confirms && data?.form_pages.page_completes) {
        dataForm.setting_page['pages'] = dataForm.setting_page['pages'].map((pageItem) => {
            let matchingPage = '';
            switch (pageItem.title) {
                case i18n.t('managerForm.settingPage.screenInput'):
                    matchingPage = PAGE_TYPES._A[0];
                    break;
                case i18n.t('managerForm.settingPage.screenConfirm'):
                    matchingPage = PAGE_TYPES._A[1];
                    break;
                case i18n.t('managerForm.settingPage.screenComplete'):
                    matchingPage = PAGE_TYPES._A[2];
                    break;
                case i18n.t('managerForm.settingPage.pageTypeB.enterSericode'):
                    matchingPage = PAGE_TYPES._B[0];
                    break;
                case i18n.t('managerForm.settingPage.pageTypeB.lotterySericode'):
                    matchingPage = PAGE_TYPES._B[1];
                    break;
                case i18n.t('managerForm.settingPage.pageTypeB.winningSericode'):
                    matchingPage = PAGE_TYPES._B[2];
                    break;
                case i18n.t('managerForm.settingPage.pageTypeB.rejectionSericode'):
                    matchingPage = PAGE_TYPES._B[3];
                    break;
                case i18n.t('managerForm.settingPage.screenEmail'):
                    pageItem.page_child.forEach((itemChild) => {
                        const keyIFormPage = data?.form_pages[itemChild.type_page_wl];
                        if (keyIFormPage) {
                            itemChild.name_page = keyIFormPage.title;
                            itemChild.blocks = [];
                            itemChild.extension = keyIFormPage.extension;
                            itemChild.setting_buttons = keyIFormPage.setting_buttons;
                            itemChild.setting_requires = keyIFormPage.setting_requires;
                            itemChild.setting_confirms = keyIFormPage.setting_confirms;
                        }
                    });
                    break;
            }
            if (!data?.form_pages[matchingPage]) return pageItem;
            if (data?.form_pages[matchingPage].title !== i18n.t('managerForm.settingPage.screenInput') && data?.form_pages[matchingPage]?.id) {
                pageItem.id = data?.form_pages[matchingPage]?.id;
            }
            const formatArray = Array.isArray(data?.form_pages[matchingPage]) ? data?.form_pages[matchingPage] : [data?.form_pages[matchingPage]];

            if (PAGE_TYPES._A.includes(matchingPage)) {
                if (matchingPage !== PAGE_TYPES._A[1]) {
                    pageItem.page_child = mapPageChildRes(dataForm, formatArray, matchingPage, null, typeStatusBlock);
                } else {
                    pageItem.page_child = mapPageChildRes(
                        dataForm,
                        [data?.form_pages[PAGE_TYPES._A[0]]],
                        matchingPage,
                        data?.form_pages[PAGE_TYPES._A[1]],
                        typeStatusBlock
                    );
                }
            }

            if (PAGE_TYPES._B.includes(matchingPage)) {
                if ([PAGE_TYPES._B[0], PAGE_TYPES._B[1], PAGE_TYPES._B[3]].includes(matchingPage)) {
                    // _B[0] and _B[1] now support multiple blocks like page_input
                    const bData = data?.form_pages[matchingPage];
                    if (bData) {
                        pageItem.page_child = mapPageChildRes(dataForm, [bData], matchingPage, null, typeStatusBlock);
                    }
                } else {
                    pageItem.page_child.forEach((itemChild) => {
                        const keyBFormPage = data?.form_pages[itemChild.type_page_wl];
                        if (keyBFormPage) {
                            itemChild.name_page = keyBFormPage.title;
                            itemChild.extension = keyBFormPage.extension;
                            itemChild.setting_buttons = keyBFormPage.setting_buttons
                                ? {
                                      ...itemChild.setting_buttons,
                                      ...keyBFormPage.setting_buttons
                                  }
                                : itemChild.setting_buttons;
                            itemChild.image_lottery = keyBFormPage.image_lottery;
                            itemChild.video_lottery = keyBFormPage.video_lottery;
                            itemChild.blocks = [];
                        }
                    });
                }
            }
            return pageItem;
        });
    }
};

const mapPageChildRes = (formData, arrPage, matchingPage, pageConfirmDefault, sttBlock = null) => {
    const foundInforPageConfirm = formData.setting_page.pages.find((page) => page.title === i18n.t('managerForm.settingPage.screenConfirm'));
    return arrPage.map((inputPageItem) => {
        const filteredBlocks = (inputPageItem.blocks ?? []).filter((blockItem) => {
            const pageTypeId = formData.page_type?.id || formData.page_type;
            const isEmailTypeI = blockItem.is_address_email_type_i || blockItem.extension?.is_address_email_type_i;
            if (pageTypeId === 1 && isEmailTypeI) {
                return false;
            }
            return true;
        });
        return {
            type_page_wl: matchingPage,
            order_index: inputPageItem.order_index,
            id: pageConfirmDefault?.id ?? inputPageItem.id,
            name_page: pageConfirmDefault?.title ?? inputPageItem?.title,
            is_default: inputPageItem.is_default == 1 ? true : false,
            setting_buttons: pageConfirmDefault?.setting_buttons ? pageConfirmDefault?.setting_buttons : foundInforPageConfirm?.setting_buttons,
            setting_requires: inputPageItem?.setting_requires ?? null,
            setting_confirms: inputPageItem?.setting_confirms ?? null,
            setting_layout_prize_serial: inputPageItem?.setting_layout_prize_serial
                ? initLayoutPrizeSerial(inputPageItem.setting_layout_prize_serial)
                : initLayoutPrizeSerial(),
            extension: inputPageItem?.extension ?? null,
            blocks: filteredBlocks
                .sort((oA, oB) => oA.order_index - oB.order_index)
                .map((blockItem) => {
                    return onHandleUnfoldBlock(blockItem, filteredBlocks, formData.setting_designs, sttBlock);
                })
        };
    });
};

const onHandleUnfoldBlock = (blockItem, listBlocks, settingDesigns, sttBlock = null) => {
    const itemExtension = blockItem.extension;
    const postCodeBlocks = listBlocks.filter((b) => b?.block_type === ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE);
    const getOptionValues =
        blockItem.options?.length > 0
            ? blockItem.options?.sort((oA, oB) => oA.option_index - oB.option_index)
            : blockItem.option_values?.length > 0
              ? blockItem.option_values?.sort((oA, oB) => oA.option_index - oB.option_index)
              : [];
    return {
        id: blockItem?.id,
        status_record_block: sttBlock ? sttBlock : 'edit',
        // start common block
        block_name: itemExtension?.block_name ?? '',
        block_type: itemExtension?.block_type ?? '',
        order_required: itemExtension?.order_required ?? false,
        is_scroll_none: itemExtension?.is_scroll_none ?? false,
        is_border_display: itemExtension?.is_border_display ?? false,
        is_address_email_type_i: itemExtension?.is_address_email_type_i ?? false,
        is_serial_code_type_b: itemExtension?.is_serial_code_type_b ?? false,
        custom_height: itemExtension?.custom_height ?? 300,
        order_index: blockItem.order_index,
        label: itemExtension?.label ?? '',
        input_field_size: itemExtension?.input_field_size ?? '',
        text_area_more_option: itemExtension?.text_area_more_option ?? '',
        confirmation_page_display: itemExtension?.confirmation_page_display ?? 1,
        personal_information_setting: itemExtension?.personal_information_setting ?? false,
        placeholder: itemExtension?.placeholder ?? '',
        max_characters: itemExtension?.max_characters ?? '255',
        number_of_items_displayed_per_line: itemExtension?.number_of_items_displayed_per_line ?? 1,
        choice_placement_specification_question:
            itemExtension?.choice_placement_specification_question ??
            onHandleGetValueTextAlign(settingDesigns.table_settings.question_text_alignment.horizontal) ??
            '',
        choice_placement_specification_answer:
            itemExtension?.choice_placement_specification_answer ??
            onHandleGetValueTextAlign(settingDesigns.table_settings.answer_text_alignment.horizontal) ??
            '',
        layout: itemExtension?.layout ?? 'default',
        if_conditions_do_not_match: itemExtension?.if_conditions_do_not_match ?? '',
        default_choice: itemExtension?.default_choice ?? null,
        default_choices: itemExtension?.default_choices ?? [],
        value_default_text: itemExtension?.value_default_text ?? '',
        unselected_label: itemExtension?.unselected_label ?? '',
        input_format: onHandleInputFormat(itemExtension),
        cell_background_color: {
            bg_question: itemExtension?.cell_background_color.bg_question ?? '',
            bg_answer: itemExtension?.cell_background_color.bg_answer ?? '',
            is_bg_question_default: itemExtension?.cell_background_color.is_bg_question_default ?? true,
            is_bg_answer_default: itemExtension?.cell_background_color.is_bg_answer_default ?? true
        },
        input_condition: {
            type: itemExtension?.input_condition?.type ?? 'AND',
            conditions: itemExtension?.input_condition?.conditions ?? [],
            status: itemExtension?.input_condition?.status ?? 1
        },
        additional_setting: {
            error_message_block: handleDataErrorMsg(blockItem.error_messages, 'res'),
            note_left_block: itemExtension?.note_left_block ?? '',
            note_right_block: itemExtension?.note_right_block ?? '',
            note_bottom_block: itemExtension?.note_bottom_block ?? ''
        },
        setting_others: {
            other_use: itemExtension?.setting_others?.other_use ?? false,
            label_other: itemExtension?.setting_others?.label_other ?? 'その他',
            value_other_required: itemExtension?.setting_others?.value_other_required ?? false,
            width_other: itemExtension?.setting_others?.width_other ?? '',
            uncheck_use: itemExtension?.setting_others?.uncheck_use ?? false,
            label_uncheck: itemExtension?.setting_others?.label_uncheck ?? i18n.t('managerForm.settingPage.uncheckCheckbox')
        },
        option_unselected_label: {
            option_index: 0,
            unique_key: null,
            value: itemExtension?.unselected_label ?? '',
            number_of_receptions: null
        },
        option_value: getOptionValues,
        // end common block
        block_checkbox: {
            operator_limit_check: itemExtension?.operator_limit_check ?? null,
            number_limit_check: itemExtension?.number_limit_check ?? ''
        },
        block_div_2: {
            label_q: itemExtension?.label_q ?? '',
            label_a: itemExtension?.label_a ?? ''
        },
        block_input: {
            minimum_number: itemExtension?.minimum_number ?? '',
            maximum_number: itemExtension?.maximum_number ?? '',
            from_range: itemExtension?.from_range ?? '',
            to_range: itemExtension?.to_range ?? '',
            number_after_decimal_point: itemExtension?.number_after_decimal_point ?? '',
            auto_complete: itemExtension?.auto_complete ?? 1,
            number_of_digits: itemExtension?.number_of_digits ?? 15,
            number_of_decimal_places: itemExtension?.number_of_decimal_places ?? 5,
            duplicate_input: itemExtension?.duplicate_input ?? 2,
            confirm_input_twice: itemExtension?.confirm_input_twice ?? 2,
            is_bank_code: itemExtension?.is_bank_code ?? false,
            is_store_number: itemExtension?.is_store_number ?? false,
            is_account_number: itemExtension?.is_account_number ?? false,
            age_condition: itemExtension?.age_condition
                ? {
                      operator: itemExtension.age_condition.operator
                          ? OPTION_AGE_CONDITION.find(
                                (o) =>
                                    o.id === itemExtension.age_condition.operator?.id ||
                                    o.value === itemExtension.age_condition.operator?.value ||
                                    o.id === itemExtension.age_condition.operator ||
                                    o.value === itemExtension.age_condition.operator
                            ) || itemExtension.age_condition.operator
                          : null,
                      value: itemExtension.age_condition.value ?? ''
                  }
                : { operator: null, value: '' },
            id_input_post_code: onHandleSetInfoPostCodeForBlockSearchAddress(postCodeBlocks, blockItem)?.id_input_post_code,
            prefecture_insertion: onHandleSetInfoPostCodeForBlockSearchAddress(postCodeBlocks, blockItem)?.prefecture_insertion,
            city_insertion: onHandleSetInfoPostCodeForBlockSearchAddress(postCodeBlocks, blockItem)?.city_insertion,
            town_area_name_insertion: onHandleSetInfoPostCodeForBlockSearchAddress(postCodeBlocks, blockItem)?.town_area_name_insertion
        },
        block_select_province: {
            id_input_post_code: onHandleSetInfoPostCodeForBlockSearchAddress(postCodeBlocks, blockItem)?.id_input_post_code,
            prefecture_insertion: onHandleSetInfoPostCodeForBlockSearchAddress(postCodeBlocks, blockItem)?.prefecture_insertion,
            city_insertion: onHandleSetInfoPostCodeForBlockSearchAddress(postCodeBlocks, blockItem)?.city_insertion,
            town_area_name_insertion: onHandleSetInfoPostCodeForBlockSearchAddress(postCodeBlocks, blockItem)?.town_area_name_insertion
        },
        block_text_area: {
            rows: itemExtension?.rows ?? '',
            cols: itemExtension?.cols ?? ''
        },
        block_date: {
            format_year: {
                type: itemExtension?.format_year?.type ?? 1,
                placeholder: itemExtension?.format_year?.placeholder ?? '',
                type_calendar: itemExtension?.format_year?.type_calendar ?? 1,
                lower_limit: itemExtension?.format_year?.lower_limit ?? '',
                upper_limit: itemExtension?.format_year?.upper_limit ?? ''
            },
            format_month_day: {
                type: itemExtension?.format_month_day?.type ?? 1,
                placeholder_month: itemExtension?.format_month_day?.placeholder_month ?? '',
                placeholder_day: itemExtension?.format_month_day?.placeholder_day ?? ''
            },
            select_value_default: itemExtension.select_value_default
        },
        block_full_name: {
            placeholder_last_name: itemExtension?.placeholder_last_name ?? '',
            placeholder_first_name: itemExtension?.placeholder_first_name ?? ''
        },
        block_post_code: {
            feature_search_address: itemExtension?.feature_search_address ?? 2,
            placeholder_1: itemExtension?.placeholder_1 ?? '',
            placeholder_2: itemExtension?.placeholder_2 ?? '',
            prefecture_insertion: itemExtension?.prefecture_insertion?.id
                ? listBlocks.find((item) => item.id === itemExtension.prefecture_insertion?.id)
                : null,
            city_insertion: itemExtension?.city_insertion?.id ? listBlocks.find((item) => item.id === itemExtension?.city_insertion?.id) : null,
            town_area_name_insertion: itemExtension.town_area_name_insertion?.id
                ? listBlocks.find((item) => item.id === itemExtension.town_area_name_insertion?.id)
                : null
        },
        block_phone: {
            placeholder_1: itemExtension?.placeholder_1 ?? '',
            placeholder_2: itemExtension?.placeholder_2 ?? '',
            placeholder_3: itemExtension?.placeholder_3 ?? ''
        },
        block_remaining_number: {
            remaining_number: itemExtension?.remaining_number ?? 1,
            display_content: itemExtension?.display_content ?? 1,
            remaining_text: itemExtension?.remaining_text ?? '残り',
            text_after_remaining_number: itemExtension?.text_after_remaining_number ?? '席',
            remaining_ratio: itemExtension?.remaining_ratio ?? '',
            label_other: itemExtension?.label_other ?? '(残りわずか)',
            color_text: itemExtension?.color_text ?? '#D83636'
        },
        block_keyword_box: {
            matching_condition: itemExtension?.matching_condition ?? [1, 2, 3],
            field_mask_display: itemExtension?.field_mask_display ?? 2,
            keyword_characters: itemExtension?.keyword_characters ?? '',
            duplicate_input: itemExtension?.duplicate_input ?? 2
        },
        block_parameter: {
            source_param: itemExtension?.source_param ?? 1,
            param_name: itemExtension?.param_name ?? '',
            error_redirect_url: itemExtension?.error_redirect_url ?? '',
            is_duplicate: itemExtension?.is_duplicate ?? 2
        },
        block_upload_file: {
            maximum_file_size: convertKBtoMB(itemExtension?.maximum_file_size) ?? '',
            allowed_extensions: itemExtension?.allowed_extensions?.toString() ?? ''
        },
        // For prizes
        is_lottery: blockItem.is_lottery ?? itemExtension?.is_lottery ?? false,
        is_rejection: blockItem.is_rejection ?? itemExtension?.is_rejection ?? false,
        is_default_display: blockItem.is_default_display ?? itemExtension?.is_default_display ?? false
    };
};

const onHandleSetInfoPostCodeForBlockSearchAddress = (listPostCodeBlock, blockItem) => {
    const foundIdPostCodeForInput = listPostCodeBlock.find(
        (item) =>
            item.extension?.prefecture_insertion?.id === blockItem.id ||
            item.extension?.city_insertion?.id === blockItem.id ||
            item.extension?.town_area_name_insertion?.id === blockItem.id
    );
    return {
        id_input_post_code: foundIdPostCodeForInput?.id,
        prefecture_insertion: foundIdPostCodeForInput?.extension?.prefecture_insertion,
        city_insertion: foundIdPostCodeForInput?.extension?.city_insertion,
        town_area_name_insertion: foundIdPostCodeForInput?.extension?.town_area_name_insertion
    };
};

const onHandleInputFormat = (formatInput) => {
    const varInputFormat = formatInput?.input_format?.id ?? formatInput?.input_format;
    if (formatInput.block_type === ALL_BLOCK_TYPE.BLOCK_FULL_NAME) {
        return formatInput?.input_format
            ? OPTION_INPUT_FORMAT_FULL_NAME.find((oformat) => oformat.id === varInputFormat)
            : OPTION_INPUT_FORMAT_FULL_NAME[0];
    } else if (formatInput.block_type === ALL_BLOCK_TYPE.BLOCK_INPUT) {
        return varInputFormat ? OPTION_INPUT_FORMAT.find((oformat) => oformat.id === varInputFormat) : OPTION_INPUT_FORMAT[0];
    }
};

const handleDataFormPage = (initData) => {
    initData.setting_page.pages.forEach((pageItem) => {
        pageItem.page_child.forEach((pageChildItem) => {
            switch (pageChildItem.type_page_wl) {
                // type A, C
                case PAGE_TYPES._A[0]:
                case PAGE_TYPES._C[0]: {
                    const pageInputs = initData.form_pages.page_inputs;
                    initData.form_pages[pageChildItem.type_page_wl] = {
                        ...(pageChildItem.id !== null &&
                            pageChildItem.id !== undefined && {
                                id: pageChildItem.id
                            }),
                        title: pageChildItem.name_page,
                        blocks: pageChildItem.blocks.map((blockItem, idx) => {
                            return onHandleSendListBlock(blockItem, idx, pageChildItem.blocks);
                        }),
                        setting_buttons: {
                            img_btn_register: pageInputs?.setting_buttons?.img_btn_register?.id
                                ? {
                                      id: pageInputs?.setting_buttons?.img_btn_register?.id
                                  }
                                : null,
                            label_btn_register: pageInputs?.setting_buttons?.label_btn_register ?? i18n.t('managerForm.settingPage.btnSaveForm')
                        },
                        setting_requires: pageInputs?.setting_requires ? { ...pageInputs.setting_requires } : null,
                        setting_confirms: pageInputs?.setting_confirms ? { ...pageInputs.setting_confirms } : null
                    };
                    break;
                }
                case PAGE_TYPES._A[1]: {
                    const pageConfirms = initData.form_pages.page_confirms;
                    initData.form_pages[pageChildItem.type_page_wl] = {
                        ...(pageChildItem?.id !== null &&
                            pageChildItem?.id !== undefined && {
                                id: pageChildItem.id
                            }),
                        setting_buttons: {
                            img_btn_confirm: pageConfirms?.setting_buttons?.img_btn_confirm?.id
                                ? {
                                      id: pageConfirms?.setting_buttons?.img_btn_confirm?.id
                                  }
                                : null,
                            img_btn_back: pageConfirms?.setting_buttons?.img_btn_back?.id
                                ? {
                                      id: pageConfirms?.setting_buttons?.img_btn_back?.id
                                  }
                                : null,
                            label_btn_confirm: pageConfirms?.setting_buttons?.label_btn_confirm ?? '登録',
                            label_btn_back: pageConfirms?.setting_buttons?.label_btn_back ?? '戻る'
                        },
                        title: pageChildItem.name_page,
                        is_default: pageChildItem.is_default
                    };
                    break;
                }
                case PAGE_TYPES._A[2]:
                    initData.form_pages[pageChildItem.type_page_wl] = {
                        ...(pageChildItem?.id !== null &&
                            pageChildItem?.id !== undefined && {
                                id: pageChildItem.id
                            }),
                        is_default: pageChildItem.is_default,
                        title: pageChildItem.name_page,
                        blocks: pageChildItem.blocks.map((blockItem, idx) => {
                            return onHandleSendListBlock(blockItem, idx);
                        })
                    };
                    break;

                // type I
                case PAGE_TYPES._I[0]:
                    initData.form_pages[pageChildItem.type_page_wl] = {
                        title: pageChildItem.name_page,
                        extension: {
                            content: pageChildItem?.extension?.content || '',
                            confirm_input_twice: pageChildItem?.extension?.confirm_input_twice ?? true
                        },
                        setting_buttons: {
                            img_btn_register: pageChildItem?.setting_buttons?.img_btn_register?.id
                                ? {
                                      id: pageChildItem?.setting_buttons?.img_btn_register?.id
                                  }
                                : null,
                            label_btn_register: pageChildItem?.setting_buttons?.label_btn_register ?? i18n.t('managerForm.settingPage.btnSaveForm')
                        },
                        setting_requires: pageChildItem?.setting_requires ? { ...pageChildItem.setting_requires } : null,
                        setting_confirms: pageChildItem?.setting_confirms ? { ...pageChildItem.setting_confirms } : null
                    };
                    break;
                case PAGE_TYPES._I[1]:
                    initData.form_pages[pageChildItem.type_page_wl] = {
                        title: pageChildItem.name_page,
                        extension: {
                            content: pageChildItem?.extension?.content || ''
                        },
                        setting_buttons: {
                            label_btn_confirm: pageChildItem?.setting_buttons?.label_btn_confirm ?? '登録',
                            label_btn_back: pageChildItem?.setting_buttons?.label_btn_back ?? '戻る',
                            img_btn_confirm: pageChildItem?.setting_buttons?.img_btn_confirm?.id
                                ? {
                                      id: pageChildItem?.setting_buttons?.img_btn_confirm?.id
                                  }
                                : null,
                            img_btn_back: pageChildItem?.setting_buttons?.img_btn_back?.id
                                ? {
                                      id: pageChildItem?.setting_buttons?.img_btn_back?.id
                                  }
                                : null
                        }
                    };
                    break;
                case PAGE_TYPES._I[2]:
                    initData.form_pages[pageChildItem.type_page_wl] = {
                        title: pageChildItem.name_page,
                        extension: {
                            content: pageChildItem?.extension?.content || ''
                        }
                    };
                    break;

                case PAGE_TYPES._B[0]: {
                    const pageSerialInput = initData.form_pages[pageChildItem.type_page_wl];
                    initData.form_pages[pageChildItem.type_page_wl] = {
                        ...(pageChildItem.id !== null &&
                            pageChildItem.id !== undefined && {
                                id: pageChildItem.id
                            }),
                        title: pageSerialInput?.name_page ?? pageChildItem.name_page,
                        blocks: pageChildItem.blocks.map((blockItem, idx) => {
                            return onHandleSendListBlock(blockItem, idx, pageChildItem.blocks);
                        }),
                        setting_buttons: {
                            img_btn_register: pageSerialInput?.setting_buttons?.img_btn_register?.id
                                ? {
                                      id: pageSerialInput?.setting_buttons?.img_btn_register?.id
                                  }
                                : null,
                            label_btn_register: pageSerialInput?.setting_buttons?.label_btn_register ?? i18n.t('managerForm.settingPage.btnSaveForm')
                        },
                        setting_requires: pageSerialInput?.setting_requires ? { ...pageSerialInput.setting_requires } : null,
                        setting_confirms: pageSerialInput?.setting_confirms ? { ...pageSerialInput.setting_confirms } : null,
                        setting_layout_prize_serial: {
                            ...pageSerialInput?.setting_layout_prize_serial
                        }
                    };
                    break;
                }
                case PAGE_TYPES._B[1]: {
                    const pageLottery = initData.form_pages[pageChildItem.type_page_wl];
                    initData.form_pages[pageChildItem.type_page_wl] = {
                        ...(pageChildItem.id !== null &&
                            pageChildItem.id !== undefined && {
                                id: pageChildItem.id
                            }),
                        title: pageLottery?.name_page ?? pageChildItem.name_page,
                        blocks: pageChildItem.blocks.map((blockItem, idx) => {
                            return onHandleSendListBlock(blockItem, idx, pageChildItem.blocks);
                        }),
                        extension: pageChildItem?.extension
                    };
                    break;
                }
                case PAGE_TYPES._B[3]: {
                    const pageRejection = initData.form_pages[pageChildItem.type_page_wl];
                    initData.form_pages[pageChildItem.type_page_wl] = {
                        ...(pageChildItem.id !== null &&
                            pageChildItem.id !== undefined && {
                                id: pageChildItem.id
                            }),
                        title: pageRejection?.name_page ?? pageChildItem.name_page,
                        blocks: pageChildItem.blocks.map((blockItem, idx) => {
                            return onHandleSendListBlock(blockItem, idx, pageChildItem.blocks);
                        }),
                        extension: pageChildItem?.extension
                    };
                    break;
                }
            }
        });
    });

    return initData.form_pages;
};

const findOrderIndexBlock = (id, listBlocks) => {
    const blockIndex = listBlocks.findIndex((block) => block.id === id);
    return blockIndex;
};

const onHandleSendListBlock = (blockItem, idx, listBlocks) => {
    return {
        order_index: idx,
        ...(blockItem.status_record_block !== 'create' && {
            id: blockItem.id
        }),
        block_type: blockItem.block_type,
        block_name: blockItem.block_name,
        option_values: onHandleSendOptionValue(blockItem),
        extension: {
            block_name: blockItem.block_name ?? '',
            block_type: blockItem.block_type ?? '',
            order_required: blockItem.order_required ?? '',
            is_scroll_none: blockItem.is_scroll_none ?? false,
            is_border_display: blockItem.is_border_display ?? false,
            is_address_email_type_i: blockItem.is_address_email_type_i ?? false,
            is_serial_code_type_b: blockItem.is_serial_code_type_b ?? false,
            is_lottery: blockItem.is_lottery ?? false,
            is_default_display: blockItem.is_default_display ?? false,
            is_rejection: blockItem.is_rejection ?? false,
            custom_height: blockItem.custom_height ?? 300,
            label: blockItem.label ?? '',
            input_field_size: blockItem.input_field_size ?? '',
            text_area_more_option: blockItem.text_area_more_option ?? '',
            confirmation_page_display: blockItem.confirmation_page_display ?? 1,
            personal_information_setting: blockItem.personal_information_setting ?? false,
            placeholder: blockItem.placeholder ?? '',
            max_characters: blockItem.max_characters?.toString() ?? '255',
            number_of_items_displayed_per_line: blockItem.number_of_items_displayed_per_line ?? 1,
            layout: blockItem.layout ?? 'default',
            if_conditions_do_not_match: blockItem.if_conditions_do_not_match ?? '',
            default_choice: blockItem.default_choice ?? null,
            default_choices: blockItem.default_choices ?? [],
            value_default_text: blockItem.value_default_text ?? '',
            unselected_label: blockItem?.unselected_label ?? '',
            input_format: blockItem?.input_format?.id ?? '',
            cell_background_color: {
                bg_question: blockItem.cell_background_color.bg_question ?? '',
                bg_answer: blockItem.cell_background_color.bg_answer ?? '',
                is_bg_question_default: blockItem.cell_background_color.is_bg_question_default ?? true,
                is_bg_answer_default: blockItem.cell_background_color.is_bg_answer_default ?? true
            },
            input_condition: {
                type: blockItem?.input_condition?.type ?? '',
                conditions:
                    blockItem.input_condition?.conditions.map((item) => {
                        return {
                            block_id: item.block.id,
                            ...item,
                            order_index: findOrderIndexBlock(item.block.id, listBlocks)
                        };
                    }) ?? [],
                status: [ALL_BLOCK_TYPE.BLOCK_DISPLAY_1, ALL_BLOCK_TYPE.BLOCK_DISPLAY_2].includes(blockItem.block_type)
                    ? 2
                    : blockItem?.input_condition?.status
            },
            ...onHandleDataBlockType(blockItem),
            note_left_block: blockItem?.additional_setting?.note_left_block ?? '',
            note_right_block: blockItem?.additional_setting?.note_right_block ?? '',
            note_bottom_block: blockItem?.additional_setting?.note_bottom_block ?? ''
        },
        error_messages: handleDataErrorMsg(blockItem.additional_setting.error_message_block)
    };
};

const onHandleSendOptionValue = (ItemBlock) => {
    const optionValues = cloneDeep(ItemBlock.option_value).map((ov, idx) => {
        if (ov.id !== undefined || ov.id !== null) {
            ov.id;
        }
        ov.option_index = idx;
        ov.unique_key = ov.unique_key.toString();
        ov.value = ov.value ? ov.value : ItemBlock.block_name;
        return ov;
    });
    switch (ItemBlock.block_type) {
        case ALL_BLOCK_TYPE.BLOCK_RADIO:
        case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
        case ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE:
        case ALL_BLOCK_TYPE.BLOCK_SELECT:
        case ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY:
            return optionValues;
        default:
            return optionValues;
    }
};

const onHandleDataBlockType = (inforAllBlock) => {
    let objType = null;
    let placementBlock = {
        choice_placement_specification_question: inforAllBlock.choice_placement_specification_question ?? '',
        choice_placement_specification_answer: inforAllBlock.choice_placement_specification_answer ?? ''
    };
    switch (inforAllBlock.block_type) {
        case ALL_BLOCK_TYPE.BLOCK_RADIO:
            objType = {
                ...placementBlock,
                setting_others: inforAllBlock.setting_others
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
            objType = {
                ...inforAllBlock.block_checkbox,
                ...placementBlock,
                setting_others: inforAllBlock.setting_others
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE:
            objType = {
                ...inforAllBlock.block_upload_file,
                maximum_file_size: convertMbToKb(inforAllBlock?.block_upload_file?.maximum_file_size)?.toString(),
                allowed_extensions: inforAllBlock?.block_upload_file?.allowed_extensions
                    ? inforAllBlock?.block_upload_file?.allowed_extensions?.split(',')
                    : null
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY:
            objType = {
                ...inforAllBlock.block_remaining_number,
                ...placementBlock,
                setting_others: inforAllBlock.setting_others
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_DISPLAY_2:
            objType = {
                ...inforAllBlock.block_div_2
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_INPUT:
            objType = {
                ...inforAllBlock.block_input
            };
            delete objType.id_input_post_code;
            delete objType.prefecture_insertion;
            delete objType.city_insertion;
            delete objType.town_area_name_insertion;
            break;
        case ALL_BLOCK_TYPE.BLOCK_TEXTAREA:
            objType = {
                ...inforAllBlock.block_text_area
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_DATE:
            objType = {
                ...inforAllBlock.block_date
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_FULL_NAME:
            objType = {
                ...inforAllBlock.block_full_name
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
            objType = {
                ...inforAllBlock.block_post_code,
                prefecture_insertion: onHandleFormatPCT(inforAllBlock.block_post_code.prefecture_insertion, inforAllBlock),
                city_insertion: onHandleFormatPCT(inforAllBlock.block_post_code.city_insertion, inforAllBlock),
                town_area_name_insertion: onHandleFormatPCT(inforAllBlock.block_post_code.town_area_name_insertion, inforAllBlock)
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
            objType = {
                ...inforAllBlock.block_phone
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX:
            objType = {
                ...inforAllBlock.block_keyword_box
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION:
            objType = {
                ...inforAllBlock.block_parameter
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_DISPLAY_1:
            objType = {
                content: inforAllBlock.label
            };
            break;
        case ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE:
            objType = {
                ...inforAllBlock?.block_select_province
            };
            break;
    }
    return objType;
};

const onHandleFormatPCT = (dataFormat, originBlock) => {
    return {
        id: [originBlock?.status_record_block, dataFormat?.status_record_block].includes('create') ? null : dataFormat?.id ?? null,
        block_name: dataFormat?.block_name ?? null
    };
};

const handleDataErrorMsg = (data, type = 'req') => {
    if (type === 'res') {
        return data.map((itemError) => {
            return {
                label_id: itemError.label_id,
                messages: itemError.message,
                type_msg: itemError.type_msg,
                required_value_other: itemError?.required_value_other ?? false,
                required_input: itemError?.required_input ?? false
            };
        });
    } else {
        return data.map((itemError) => {
            return {
                label_id: itemError.label_id,
                message: itemError.messages,
                type_msg: itemError.type_msg,
                required_value_other: itemError?.required_value_other ?? false,
                required_input: itemError?.required_input ?? false
            };
        });
    }
};

const validateTableWidth = (tableWidth, answerWidth, questionWidth) => {
    if (Number(questionWidth.valueSync) + Number(answerWidth.valueSync) > Number(tableWidth.valueSync)) {
        questionWidth.error = true;
        answerWidth.error = true;
        tableWidth.error = true;
        tableWidth.errorCustomMess = '質問欄と回答欄の幅の合計は、テーブル幅を超えないようにしてください。';
        return false;
    } else {
        questionWidth.error = false;
        answerWidth.error = false;
        tableWidth.error = false;
        tableWidth.errorCustomMess = '';
        return true;
    }
};
const handleAlertValidateTabs = (conditionTab, bvToast, modelTab, newTabs) => {
    let check = true;
    const titleTab = TAB_NAME;
    const tabBasic = !conditionTab.checkFormBasic || !conditionTab.checkStarPublichWithEndPublic || !conditionTab.checkTabSettingLottery;
    const tabSettingPage = !conditionTab.checkFormPage;
    const tabSettingDesign = !conditionTab.checkSettingDesign;
    const tabSettingMail = !conditionTab.checkTabSettingMail;
    const tabSettingCalendar = !conditionTab.checkTabSettingCalendar;
    const getNameTab = newTabs[modelTab]?.name ?? '';

    if (tabBasic && getNameTab !== titleTab.basic) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.basic
            })
        );
    }
    if (tabSettingDesign && getNameTab !== titleTab.design) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.design
            })
        );
    }
    if (tabSettingPage && getNameTab !== titleTab.page) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.page
            })
        );
    }
    if (tabSettingMail && getNameTab !== titleTab.page_setting_mail_type_i) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.page_setting_mail_type_i
            })
        );
    }
    if (tabSettingCalendar && getNameTab !== titleTab.page_setting_calendar_lottery) {
        showMessage(
            8080,
            bvToast,
            i18n.t('validateField.tabs', {
                field: titleTab.page_setting_calendar_lottery
            })
        );
    }

    let targetInvalidTabIndex = -1;
    const isCurrentTabInvalid =
        (getNameTab === titleTab.basic && tabBasic) ||
        (getNameTab === titleTab.design && tabSettingDesign) ||
        (getNameTab === titleTab.page && tabSettingPage) ||
        (getNameTab === titleTab.page_setting_mail_type_i && tabSettingMail) ||
        (getNameTab === titleTab.page_setting_calendar_lottery && tabSettingCalendar);

    if (isCurrentTabInvalid) {
        targetInvalidTabIndex = modelTab;
    } else {
        for (let i = 0; i < newTabs.length; i++) {
            const tab = newTabs[i];
            if (tab.name === titleTab.basic && tabBasic) {
                targetInvalidTabIndex = i;
                break;
            }
            if (tab.name === titleTab.design && tabSettingDesign) {
                targetInvalidTabIndex = i;
                break;
            }
            if (tab.name === titleTab.page && tabSettingPage) {
                targetInvalidTabIndex = i;
                break;
            }
            if (tab.name === titleTab.page_setting_mail_type_i && tabSettingMail) {
                targetInvalidTabIndex = i;
                break;
            }
            if (tab.name === titleTab.page_setting_calendar_lottery && tabSettingCalendar) {
                targetInvalidTabIndex = i;
                break;
            }
        }
    }

    if (tabBasic || tabSettingPage || tabSettingDesign || tabSettingMail || tabSettingCalendar) {
        check = false;
    }

    return {
        check,
        firstInvalidTabIndex: targetInvalidTabIndex
    };
};

const onHandleCheckboxLimited = (inforBlock, defaultForm, disabledLimit, typeHandle) => {
    if (inforBlock.block_type === ALL_BLOCK_TYPE.BLOCK_CHECKBOX) {
        if (inforBlock.block_checkbox.operator_limit_check && inforBlock.block_checkbox.number_limit_check) {
            const operator = inforBlock.block_checkbox.operator_limit_check.value;
            const limit = Number(inforBlock.block_checkbox.number_limit_check);
            let checked = [];
            if (typeHandle === 'action') {
                checked = defaultForm.choiceValues ?? defaultForm.checked;
            } else if (typeHandle === 'created') {
                checked = defaultForm?.choiceValues ?? inforBlock.default_choices;
            }

            const isDisabled = (checkedLength, operator, limit) => {
                switch (operator) {
                    case '=':
                        return checkedLength == limit;
                    case '≦':
                        return checkedLength <= limit && checkedLength === limit;
                    default:
                        return false;
                }
            };
            const disable = isDisabled(checked.length, operator, limit);
            inforBlock.option_value.forEach((optionItem) => {
                const isIncluded = checked.includes(optionItem.unique_key);
                disabledLimit[Number(optionItem.unique_key)] = disable && !isIncluded;
            });
            disabledLimit[VALUE_ETC] = disable && !checked.includes(VALUE_ETC);
            disabledLimit[VALUE_NAC] = disable && !checked.includes(VALUE_NAC);
        } else {
            inforBlock.option_value.forEach((optionItem) => {
                disabledLimit[Number(optionItem.unique_key)] = false;
            });
            disabledLimit[VALUE_ETC] = false;
            disabledLimit[VALUE_NAC] = false;
        }
        return disabledLimit;
    }
};

const FORMAT_VALUE_PHONE = (data, position) => {
    if (!data || !position.toString()) return '';
    return data.split('-')[position];
};

const FORMAT_VALUE_INPUT = (data, position) => {
    if (!data || !position.toString()) return '';
    return data.split('<<CONFIRMTEXT>>')[position];
};

const onHandleMergeOptionValues = (opm, inforBlock) => {
    inforBlock.option_unselected_label.value = inforBlock.unselected_label;
    return [inforBlock.option_unselected_label, ...opm];
};

const handleMapDataCPIntoForm = (dataForm, allInforCampaignForm) => {
    if (dataForm.campaign?.id && !dataForm.client) {
        dataForm.client = allInforCampaignForm?.client_generate_file ?? null;
    }

    if (!dataForm.setting_lottery.start_date) {
        dataForm.setting_lottery.start_date = formatDateCommon(allInforCampaignForm.campaign_start_date, 'date');
    }
    if (!dataForm.setting_lottery.end_date) {
        dataForm.setting_lottery.end_date = formatDateCommon(allInforCampaignForm.campaign_end_date, 'date');
    }

    return dataForm;
};

const validateEndDate = (startDateStr, endDateStr) => {
    let check = true;
    const startDate = moment(startDateStr.valueSync, STR_DATE_TIME);
    const endDate = moment(endDateStr.valueSync, STR_DATE_TIME);
    const nowJapan = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
    const startDateJP = new Date(startDateStr.valueSync.replace(' ', 'T'));
    const endDateJP = new Date(endDateStr.valueSync.replace(' ', 'T'));
    if (startDateJP < nowJapan) {
        check = false;
        startDateStr.error = true;
        startDateStr.errorText = `公開開始日時には現在日時より前の時刻は設定できません。`;
    }
    if (endDateJP < nowJapan) {
        check = false;
        endDateStr.error = true;
        endDateStr.errorText = `公開終了日時には現在日時より前の時刻は設定できません。`;
    }
    if (!startDateStr.valueSync || !endDateStr.valueSync) return check;
    if (!endDate.isSameOrAfter(startDate)) {
        check = false;
        endDateStr.error = true;
        endDateStr.errorText = `${startDateStr.errorField}は${endDateStr.errorField}以下である必要があります。`;
    }

    return check;
};

async function handleRecordFormError(router, idLP, bvToast) {
    const confirm = await onHandleShowConfirm({
        title: 'LPエラー',
        text: `キャンペーンが削除されたため、このLPを削除しますか。`,
        icon: 'error',
        cancelButtonColor: '#eff2f7',
        confirmButtonText: `${i18n.t('btn.ok')}`,
        cancelButtonText: `<div style="color: #212529">${i18n.t('btn.cancel')}</div>`
    });

    if (confirm) {
        const response = await managerFormService.deleteManagerForm({ id: Number(idLP) });
        router.push({ path: '/manager-form/list' }).then(() => {
            showMessage(response.code, bvToast, 'LPが削除されました。');
        });
    } else {
        router.push({
            path: '/manager-form/list'
        });
    }
}

function foundTypePageForm(typePage) {
    if (!typePage) return '';
    return PAGE_TYPE_FIXED.find((item) => item.id === typePage)?.alias || '';
}

const handleGetListSerial = async (context, params = {}) => {
    const defaultConfig = {
        isLoadingListSerial: false,
        ...context.CONFIG_TABLE_IMPORT
    };
    defaultConfig.isLoadingListSerial = false;
    let queryApi = params?.query || `?page=${defaultConfig.configPage.page}&limit=${defaultConfig.configPage.limit}`;
    try {
        const payload = {
            form_id: context.formData.id,
            query: queryApi
        };
        const dataRes = await context.getListSerialCode(payload);
        if (queryApi.includes('lookup?serial_code')) {
            return dataRes.data;
        }
        context.formData.setting_serial_code = {
            ...context.formData.setting_serial_code,
            serial_codes: dataRes.data?.length > 0 ? dataRes.data?.map((item) => ({ ...item, make_id: item.id })) : []
        };
        defaultConfig.configPage.total = dataRes._metadata.total;
        defaultConfig.configPage.totalSerialCode = dataRes._metadata.serial_codes_total;
        defaultConfig.configPage.limit = dataRes._metadata.limit * 1;
    } catch (error) {
        console.log('error', error);
    } finally {
        defaultConfig.isLoadingListSerial = false;
    }
};

const onCheckDisableTemplate = (baseType, targetType) => {
    if (!baseType) return false;

    if (baseType === ID_PAGE_TYPE.I) {
        return targetType !== ID_PAGE_TYPE.I;
    } else if (baseType === ID_PAGE_TYPE.C) {
        return targetType !== ID_PAGE_TYPE.C;
    }
    return targetType === ID_PAGE_TYPE.I || targetType === ID_PAGE_TYPE.C;
};

const onHandleGetListTemporarily = async (context) => {
    try {
        const data = await context.getListTemplateManagerForm();
        context.temporarilyList =
            data?.data.map((item) => {
                const currentType = context?.formData?.page_type?.id;
                const itemType = Number(item?.type);
                const disable = onCheckDisableTemplate(currentType, itemType);

                return {
                    ...item,
                    $isDisabled: disable
                };
            }) ?? [];
    } catch (error) {
        console.log('error', error);
    }
};

const onHandleTemporarily = async (evt, context) => {
    const dataFormPage = handleDataFormPage(context.formData);
    const formPagesData = context.onHandleRemoveId(dataFormPage) || {};

    let payload = {
        name: evt.name,
        type: context.formData.page_type?.id?.toString(),
        form_pages: {
            ...formPagesData
        },
        setting_designs: {
            ...handleSettingDesign(context.formData.setting_designs),
            background_image: context.formData.setting_designs?.background_image,
            design_2: {
                header: context.formData.header,
                footer: context.formData.footer,
                google_analytics: context.formData.google_analytics,
                description: context.formData.description
            }
        }
    };

    if (formPagesData.page_inputs) {
        payload.form_pages.page_inputs = {
            ...formPagesData.page_inputs,
            setting_buttons: {
                ...formPagesData.page_inputs.setting_buttons,
                img_btn_register: context.formData.form_pages?.page_inputs?.setting_buttons?.img_btn_register
            }
        };
    }

    if (formPagesData.page_confirms) {
        payload.form_pages.page_confirms = {
            ...formPagesData.page_confirms,
            setting_buttons: {
                ...formPagesData.page_confirms.setting_buttons,
                img_btn_back: context.formData.form_pages?.page_confirms?.setting_buttons?.img_btn_back,
                img_btn_confirm: context.formData.form_pages?.page_confirms?.setting_buttons?.img_btn_confirm
            }
        };
    }

    try {
        const dataRes = await context.registerTemplateManagerForm(payload);
        if (!dataRes || dataRes.code !== 200) {
            showMessage(dataRes.code, context.$bvToast, context.$t(dataRes.message));
            return;
        }
        showMessage(dataRes.code, context.$bvToast, 'テンプレートが登録されました。');
    } catch (error) {
        console.log('error', error);
        showMessage(error.code, context.$bvToast, error.message);
    }
};

export {
    handleDataBeforeSendServer,
    handleDataResponse,
    handleStatus,
    handleAlertValidateTabs,
    onHandleCheckboxLimited,
    FORMAT_VALUE_PHONE,
    FORMAT_VALUE_INPUT,
    onHandleMergeOptionValues,
    handleMapDataCPIntoForm,
    validateEndDate,
    onHandleInputFormat,
    handleRecordFormError,
    validateTableWidth,
    handleDataFormPage,
    handleSettingDesign,
    handleMapBlockRes,
    handleMapSettingDesign,
    foundTypePageForm,
    handleGetListSerial,
    onHandleGetListTemporarily,
    onHandleTemporarily,
    onCheckDisableTemplate
};
